import React from 'react';
import styled from 'styled-components';

const Footer = styled.div`
    background: #00FFFF;
    height: 20px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
`;
export default ()=>{
    return <Footer></Footer>
}